import React from 'react';
import { connect } from 'react-redux';
import { DataTable } from '../../widgets';
import { PERMISSION_BY_ID, RECOMMENDED_ADMIN_CONTROLLERS } from '../../../constants';
import ActionInput from '../UserRoleList/ActionInput';
import LoadingStyle from './LoadingStyle';

const Permission = (props) => {
    const { controllerListById, id, isRequesting, permissionInfo, updatePermission } = props;
    return <>
        <DataTable className="permission">
            <DataTable.Header>
                <DataTable.Row>
                    <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                    <DataTable.Cell style={{ width: "480px" }}>Controller</DataTable.Cell>
                    {Object.keys(PERMISSION_BY_ID).map(permId =>
                        <DataTable.Cell key={permId} style={{ textAlign: "center", width: "120px" }}>
                            {PERMISSION_BY_ID[permId]}
                        </DataTable.Cell>)}
                </DataTable.Row>
            </DataTable.Header>
            <DataTable.Body>
                {(!isRequesting && permissionInfo) && Object.keys(controllerListById).map((cntrlId, i) =>
                    <DataTable.Row key={`${id}_${cntrlId}`}>
                        <DataTable.Cell style={{ width: "40px" }}>{i + 1}</DataTable.Cell>
                        <DataTable.Cell>
                            {controllerListById[cntrlId].controller_display_name}
                            {RECOMMENDED_ADMIN_CONTROLLERS.includes(controllerListById[cntrlId].controller_id)
                                && <span className="ml-1 text-muted">(Recommended only for admin)</span>}
                        </DataTable.Cell>
                        {Object.keys(PERMISSION_BY_ID).map(actionId => {
                            const hasAction = controllerListById[cntrlId].actions.indexOf(parseInt(actionId)) >= 0;
                            const isChecked = permissionInfo && permissionInfo[cntrlId] ? permissionInfo[cntrlId].indexOf(parseInt(actionId)) >= 0 : false;
                            return hasAction
                                ? <DataTable.Cell key={`${id}_${cntrlId}_${actionId}`}
                                    style={{ width: "120px", textAlign: "center" }}>
                                    {(isRequesting || !permissionInfo)
                                        ? (isRequesting ? <LoadingStyle /> : <></>)
                                        : <ActionInput
                                            cntrlId={cntrlId}
                                            actionId={actionId}
                                            isChecked={isChecked}
                                            updatePermission={updatePermission} />}
                                </DataTable.Cell>
                                : <DataTable.Cell key={`${id}_${cntrlId}_${actionId}`}></DataTable.Cell>
                        })}
                    </DataTable.Row>)}
            </DataTable.Body>
        </DataTable>
        {(isRequesting || !permissionInfo)
            && (isRequesting ? <DataTable.Loading /> : <DataTable.RecordsNotFound >Fetching failed</DataTable.RecordsNotFound>)}
    </>
}

const mapStateToProps = (state) => ({
    controllerListById: state.users.controllerListById.payload
});

export default connect(mapStateToProps)(Permission);
